import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { paths, plainTerms, STARTER_TEMPLATES, type DocTemplate } from "@clevis/shared-types";
import { Select } from "@clevis/shared-ui";
import { db } from "../lib/firebase";
import { useAuth } from "../hooks/useAuth";

// "Load a template" beside a terms box: your own templates in that category,
// then the starter library's. Loading replaces the box (as plain terms).

export function TermsLoader({ category, onLoad }: { category: string; onLoad: (text: string) => void }) {
  const { tenantId } = useAuth();
  const [own, setOwn] = useState<Array<DocTemplate & { id: string }>>([]);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(
      collection(db, paths.tenantTemplates(tenantId)),
      (s) => setOwn(s.docs.map((d) => ({ id: d.id, ...(d.data() as DocTemplate) })).filter((t) => !t.archivedAt && t.category === category)),
      () => setOwn([]),
    );
  }, [tenantId, category]);
  const starters = STARTER_TEMPLATES.filter((s) => s.category === category);
  return (
    <Select
      className="w-auto py-0.5 text-xs"
      value=""
      aria-label="Load a template"
      onChange={(e) => {
        const v = e.target.value;
        const body = v.startsWith("own:") ? own.find((t) => t.id === v.slice(4))?.body : starters.find((s) => s.key === v.slice(8))?.body;
        if (body) onLoad(plainTerms(body));
      }}
    >
      <option value="">Load a template…</option>
      {own.length ? (
        <optgroup label="Your templates">
          {own.map((t) => (
            <option key={t.id} value={`own:${t.id}`}>
              {t.name}
            </option>
          ))}
        </optgroup>
      ) : null}
      <optgroup label="Starter library">
        {starters.map((s) => (
          <option key={s.key} value={`starter:${s.key}`}>
            {s.name}
          </option>
        ))}
      </optgroup>
    </Select>
  );
}
